import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { encryptionSendCode, encryptionRealName } from "@/api/php/user";
import { isPhone } from "@/uitls/is";
import { Toast } from "vant";
import { cheackQuery, ToBack } from "@/uitls/native";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'realname',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const route = useRoute();
const router = useRouter();
const subzbbg = require(`@/assets/${process.env.VUE_APP_NAME}/subzbbg_01.png`)
const th = process.env.VUE_APP_Language as string;
let form = ref({
  nickname: "", //真实姓名
  nicknumber: "", //身份证号
  phonenumber: "", //手机号
  checknumber: "", //验证码
});
const count = ref(0);
let time = null;
onMounted(() => {
  cheackQuery(route); 
});

const checkn = async () => {
  if (count.value == 0) {
    let phone = form.value.phonenumber;
    if (isPhone(phone)) {
      const res: any = await encryptionSendCode({ phone: phone });
      if (res.code == 200) {
        Toast({
          message: t('me.yazfa'),
          position: "bottom",
        });
        verifyCodeTimeAction();
      }
    } else {
      Toast({
        message: t('me.oninutphone'),
        position: "bottom",
      });
    }
  }
};
const verifyCodeTimeAction = () => {
  const TIME_COUNT = 30; //倒计时30秒
  if (!time) {
    count.value = TIME_COUNT;
    time = setInterval(() => {
      if (count.value > 0 && count.value <= TIME_COUNT) {
        count.value--;
      } else {
        clearInterval(time);
        time = null;
      }
    }, 1000);
  }
};
const ok = async () => {
  let data = true;
  if (isPhone(form.value.phonenumber)) {
    data = true;
    for (let i in form.value) {
      if (form.value[i] == "") {
        console.log(form.value[i]);
        data = false;
        Toast({
          message: t('me.qzqtx'),
          position: "bottom",
        });
        return;
      }
    }
  } else {
    data = false;
    Toast({
      message: t('me.oninutphone'),
      position: "bottom",
    });
  }

  if (data) {
    const res: any = await encryptionRealName({
      phone: form.value.phonenumber, // 手机号
      id_card: form.value.nicknumber, // 身份证号码
      name: form.value.nickname, // 姓名
      code: form.value.checknumber, // 验证码
    });
    if (res.code == 200) {
      Toast.success(t('me.tgcggg'));
    } else {
      Toast({
        message: res.msg,
        position: "bottom",
      });
    }
  }
};
const btnok = ref(false)
const checkText = () => {
  for (let i in form.value) {
    if (form.value[i] == "") {
      return;
    }
  }
  //资料都填完了，可以提交
  btnok.value = true;
}

const __returned__ = { t, route, router, subzbbg, th, form, count, time, checkn, verifyCodeTimeAction, ok, btnok, checkText, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})